import {Routes} from '@angular/router';
import {routes as employeeRoutes} from './employees/employees.routes';
import {routes as entryRoutes} from './entries/entries.routes';
import {routes as absenceRoutes} from './absence-requests/absence-requests.routes';
import {routes as publicHolidayRoutes} from './public-holidays/public-holidays.routes';
import {routes as overviewRoutes} from './overview/overview.routes';

export const routes: Routes = [
  {
    path: 'employees',
    children: employeeRoutes,
  },
  {
    path: 'entries',
    children: entryRoutes,
  },
  {
    path: 'absence-requests',
    children: absenceRoutes,
  },
  {
    path: 'public-holidays',
    children: publicHolidayRoutes,
  },
  {
    path: 'overview',
    children: overviewRoutes,
  }
];
